import { render, staticRenderFns } from "./ProjectDialog.vue?vue&type=template&id=22ee7d80&scoped=true&"
import script from "./ProjectDialog.vue?vue&type=script&lang=ts&"
export * from "./ProjectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDialog.vue?vue&type=style&index=0&id=22ee7d80&prod&lang=scss&"
import style1 from "./ProjectDialog.vue?vue&type=style&index=1&id=22ee7d80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee7d80",
  null
  
)

export default component.exports